import { trimPipes, milOrBil, sanitize, isEmpty, truncateString } from "../../_js/common/_util";

("use strict");

export default class CompanyCard {
    constructor() {}

    generateCompanyCardHTML(el) {
        let companyCardHTML = "";

        companyCardHTML += `<div class="company-card-wrap">
                            <div class="company-card">
                                <div class="company-card__header">`;
                                    companyCardHTML += `<div class="header-left"><a href="#/company/${sanitize(el[3])}" class="company-card__name">${el[3]}</a></div>`;
                                    // if (isEmpty(el[4])) {
                                    //     companyCardHTML += `<a href="#/company/${sanitize(el[3])}" class="company-card__name">${el[3]}</a>`;
                                    // } else {
                                    //     companyCardHTML += `<a href="#/company/${sanitize(el[3])}" class="company-card__name"><div class="company-card__name_en">${el[3]}</div> <span>${el[4]}</span></a>`;
                                    // }
                companyCardHTML += `<div class="header-right"><a class="company-card__logo" href="#/company/${sanitize(el[3])}">${el[8]}</a></div>
                                </div>
                                <div class="company-card__details">`;



                                    if (!isEmpty(el[4]) || !isEmpty(el[1])) {
                                    companyCardHTML += `        <ul>`;

                                    if (isEmpty(el[5])) {
                                        companyCardHTML += `        <li class="-networth"><span>Market value</span>-</li>`;
                                    } else {
                                        companyCardHTML += `        <li class="-networth"><span>Market value</span>${milOrBil(el[5])} USD</li>`;
                                    }

                                    if (!isEmpty(el[1])) {
                                        companyCardHTML += `        <li class="-type"><span>Type of company</span>${trimPipes(el[1])}</li>`;
                                    }
                                    if (!isEmpty(el[6])) {
                                        if (!isEmpty(el[7])) {
                                            companyCardHTML += `    <li class="-ceo"><span>Founder / CEO</span>${el[6]} <span class="CN-name">${el[7]}</span></li>`;
                                        } else {
                                            companyCardHTML += `    <li class="-ceo"><span>Market value</span>${el[6]}</li>`;
                                        }
                                    }
                                    if (!isEmpty(el[2])) {
                                        companyCardHTML += `        <li class="-ownership"><span>Ownership structure</span>${trimPipes(el[2])}</li>`;
                                    }
                                    companyCardHTML += `    </ul>`;
                                }

        companyCardHTML += `</div>
                            <div class="company-card__info">
                                <p>${truncateString(el[9], 120)}</p>
                                <a class="company-card__link" href="#/company/${sanitize(
                                    el[3]
                                )}">View More</a>
                            </div>
                        </div>
                        </div>`;

        return companyCardHTML;
    }
}
